export default __webpack_public_path__ + "static/omnibar-concept-light-588e97164c65a4f4b4516c362ca2e38b179158bde1cc696744c130a27d541a74.mp4";